module.exports = __webpack_public_path__ + "img/2.c1aa77a3.png";